import Icon from 'vue-awesome/components/Icon'

Icon.register({
  crop_original_rounded: {
    paths: [
      {
        d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-4.44-6.19l-2.35 3.02-1.56-1.88a.5.5 0 00-.78.01l-1.74 2.23a.5.5 0 00.39.81h8.98a.5.5 0 00.4-.8l-2.55-3.39a.498.498 0 00-.79 0z'
      }
    ],
    width: '24',
    height: '24'
  }
})
